<script setup lang="ts">
import type { Url } from '@global-types/url.ts';
import Typography from '@components/Typography.vue';

interface HelpMenuSubmenuItemProps {
  link: Url,
  isActive?: boolean,
}

withDefaults(defineProps<HelpMenuSubmenuItemProps>(), {
  isActive: false,
});
</script>

<template>
  <a
    :href="link"
    :class="[
      'help-menu-submenu-item',
      { 'help-menu-submenu-item--active': isActive },
      'rounded-lg',
      'h-11',
      'px-1',
      'flex items-center',
      'select-none no-underline',
      { 'cursor-default': isActive },
    ]"
  >
    <Typography :variant="isActive ? 'body-bold' : 'body'">
      <slot />
    </Typography>
  </a>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.help-menu-submenu-item {
  &--active {
    background-color: $colorBlueLightest;
  }

  @media (hover: hover) {
    &:hover {
      background-color: $colorBlueLightest;
    }
  }
}
</style>
